module.exports = __webpack_public_path__ + "static/media/graph.fb651ee8.png";